import "./AssignLocationModal.scss";

import AssignLocationModal from "./AssignLocationModal";

export default AssignLocationModal;